import React, { Component } from 'react';
import KickImage from 'Reuseables/KickImage';
import {
  Modal,
  Container,
  InputGroup, Input, FormGroup, InputGroupAddon } from 'reactstrap';
import { Button } from '../Forms';
import CloseIcon from '../../images/close-button-black.png';
import { TextRupiah } from '../Text';
import FormFeedback from '../Forms/FormFeedback';
import classNames from 'classnames';
import { hasError } from '../../utils/Helpers';

class ModalOffer extends Component{
  render() {
    const limit = (parseInt(this.props.dataAuth.userdata.balance) < 10000);
    return (
      <Modal
        toggle={this.props.onToggle}
        modalClassName="modal-offer-wrapper"
        isOpen={this.props.isOpen}
      >
        <div className="close-modal" style={{textAlign: 'right'}} onClick={this.props.onToggle}>
          <KickImage src={CloseIcon} alt="close"/>
        </div>
        <div className="offer-header">
          <h6>MAKE AN OFFER</h6>
        </div>
        <Container className="offer-content">
          <div className="offer-content-top">
            <p>Highest Offer: <TextRupiah color="black" text-bold="false"  value={this.props.highestOffer&&this.props.highestOffer.highest_bid!==null?this.props.highestOffer&&this.props.highestOffer.highest_bid.amount:0} prefix="IDR. "/></p>
          </div>
          <div className="offer-content-middle">
            <p>Your Offer</p>
            <FormGroup className="offer-input">
              <InputGroup >
                <InputGroupAddon addonType="prepend">RP</InputGroupAddon>
                <Input
                  name="_bidAmount"
                  value={this.props.bidAmount}
                  onChange={this.props.handleBidAmount}
                />
                {
                  this.props.error&&this.props.error.length>0?
                  <p style={{color: '#D0021B'}}>
                  { this.props.error }
                  </p>:
                  null
                }
                {/* <FormFeedback
                  errors={this.props.error!==null?this.props.error:undefined}
                  field="_bidAmount"
                /> */}
              </InputGroup>
            </FormGroup>
          </div>
          <div className="offer-content-bottom">
            <p className="text-offer-top">How does OFFER work?</p>
            {
              limit?
                <p className="text-offer-bottom">You have insufficient Kick Credit balance. Please meet the <span>requirement</span> to make an offer.</p>
              :
              null
            }
          </div>
        </Container>
        <div className="offer-footer">
          <Button 
            onClick={this.props.submitOffer}
            className={classNames('btn-white flat spacer', {'disabled': limit})}
          >
            SUBMIT OFFER
          </Button>
        </div>
      </Modal>
    )
  }
}

export default ModalOffer;